import styled from 'foundations-theming-specialty/utils';
export const StyledSettingsIconWrapper = styled.div.withConfig({
  displayName: "StyledSettingsIconWrapper",
  componentId: "sc-1han12z-0"
})(["display:", ";align-items:center;position:absolute;left:", ";top:", ";z-index:3;pointer-events:auto;cursor:pointer;user-select:none;"], ({
  isOpen
}) => isOpen ? 'flex' : 'none', ({
  theme
}) => `calc(${theme.space['600']} + calc(var(--search-layout-width, 500px) - 30px) + ${theme.space['400']})`, ({
  theme
}) => `calc(${theme.space['400']} + ${theme.space['400']})`);